import axios from 'axios'

// const url = 'http://localhost:4042/api/'

const url='/api/'

// export default (endpoint, params) => {
//     const options = {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')
//         }
//     }
//     return axios.post(url + endpoint, params, options);
// }


export default (endpoint, data, config = {}) => {
    return axios.post(url + endpoint, data, {
        ...config,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            ...config.headers,
        },
    });
};





// export default (endpoint, data, config = {}) => {
//     return axios.post(url + endpoint, data, {
//         withCredentials: true,
//         ...config,
//         headers: {
//             ...config.headers,
//         },
//     });
// };